import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from '../../../model/master/role/role';
import { HttpClient } from '@angular/common/http';
import { LeadType } from 'src/app/model/master/lead-type/LeadType';
import { User } from 'src/app/model/master/user/user';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  public submit(data: User): Observable<Role[]> {
    return this.http.post<Role[]>(`${environment.apiUrl}/Users/Insert`, data);
  }

  public search(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/Users`);
  }

  public update(data: User): Observable<Role[]> {
    return this.http.post<Role[]>(`${environment.apiUrl}/Users/Update`, data);
  }

  public GetZonesByUserID(UserID, RollNAme, ModifiedBy): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/UsersZone/GetZonesByUserID?UserID=` + UserID + `&RoleName=` + RollNAme + `&ModifiedBy=` + ModifiedBy);
  }
}
